export const CATEGORY_LIST_SUCCESS = 'CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_FAIL = 'ITEM_LIST_FAIL';
export const CATEGORY_LIST_REQUEST = 'ITEM_LIST_REQUEST';

